import React, { useEffect, useState, useMemo } from "react";
import classnames from "classnames";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Nav,
  NavItem,
  NavLink,
  Input,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Spinner,
  UncontrolledTooltip
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

const Gezilerim = () => {
  document.title = "Gezilerim | Partner Expedicar";

  const [activeTab, setActiveTab] = useState("1");
  const [tripsData, setTripsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  // OData API'den Sadece Giriş Yapan Kullanıcının Gezilerini Çekme
  useEffect(() => {
    const fetchMyTrips = async () => {
      setIsLoading(true);
      try {
        // LocalStorage'dan giriş yapan kullanıcıyı alıyoruz
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const userId = authUser?.ID;

        // Kullanıcı ID'si yoksa veri çekme işlemini durdur
        if (!userId) {
          console.warn("Gezilerim için Kullanıcı ID bulunamadı.");
          setIsLoading(false);
          return;
        }

        // SADECE bu kullanıcıya ait ilanları çekiyoruz (Araç ve Lokasyon detaylarıyla birlikte)
        const response = await fetch(
            `https://hiflowapi.stechomeyazilim.info/Advert?$filter=Users_ID eq ${userId}&$expand=Users_Car,Advert_Location`
        );
        const result = await response.json();

        if (result && result.value) {
          const formattedData = result.value.map(item => {
            const car = item.Users_Car || {};
            const location = item.Advert_Location?.[0] || {};
            
            // Tarih formatlama
            const sDate = item.Advert_DateTime ? new Date(item.Advert_DateTime) : null;
            const eDate = item.Advert_DateTime2 ? new Date(item.Advert_DateTime2) : null;

            return {
              id: item.ID,
              tags: item.Direction_Type || "", // Etiketler
              status: "Gerçekleştirildi", // İleride Advert_DeliveryStatus tablosundan dinamik alınabilir
              customer: item.Customer_Notes || "TESLA BELÇİKA",
              vehicleBody: car.Car_Body_Type || "Sedan",
              vehiclePlate: car.Users_Car_Plate || "Plaka Yok",
              startCity: `${location.Start_City_Code ? location.Start_City_Code : ''} ${location.Advert_Location_StartAddress?.split(',')[0] || ''}`,
              endCity: `${location.Finish_City_Code ? location.Finish_City_Code : ''} ${location.Advert_Location_FinishAddress?.split(',')[0] || ''}`,
              startDate: sDate ? `${sDate.toLocaleDateString('tr-TR')} saat ${sDate.getHours().toString().padStart(2, '0')}:${sDate.getMinutes().toString().padStart(2, '0')}` : "-",
              endDate: eDate ? `${eDate.toLocaleDateString('tr-TR')} saat ${eDate.getHours().toString().padStart(2, '0')}:${eDate.getMinutes().toString().padStart(2, '0')}` : "-",
              distance: location.Km ? `${location.Km} kilometre` : "-",
              bidWon: item.Price > 50, // Fiyat 50'den büyükse EVET, değilse HAYIR
              price: item.Price || 0
            };
          });
          setTripsData(formattedData);
        } else {
            setTripsData([]);
        }
      } catch (error) {
        console.error("Gezilerim verisi çekilirken hata:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMyTrips();
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "Kimlik Rezervasyon",
        accessorKey: "id",
        enableSorting: true,
        cell: (cellProps) => <span className="fw-medium">{cellProps.row.original.id}</span>
      },
      {
        header: "ETİKETLER",
        accessorKey: "tags",
        enableSorting: false,
      },
      {
        header: "Durum",
        accessorKey: "status",
        enableSorting: true,
        cell: (cellProps) => (
          <div>
            <i className="mdi mdi-circle text-success me-1"></i>
            {cellProps.row.original.status}
          </div>
        )
      },
      {
        header: "Müşteri",
        accessorKey: "customer",
        enableSorting: true,
        cell: (cellProps) => <div style={{ maxWidth: "100px", whiteSpace: "normal" }}>{cellProps.row.original.customer}</div>
      },
      {
        header: "Araç",
        accessorKey: "vehicle",
        enableSorting: false,
        cell: (cellProps) => (
          <div>
            {cellProps.row.original.vehicleBody}<br/>
            {cellProps.row.original.vehiclePlate}
          </div>
        )
      },
      {
        header: "Kalkış Şehri",
        accessorKey: "startCity",
        enableSorting: true,
      },
      {
        header: "Varış şehri",
        accessorKey: "endCity",
        enableSorting: true,
      },
      {
        header: "Kalkış tarihi",
        accessorKey: "startDate",
        enableSorting: true,
        cell: (cellProps) => <div style={{ width: "90px", whiteSpace: "normal" }}>{cellProps.row.original.startDate}</div>
      },
      {
        header: "Varış tarihi",
        accessorKey: "endDate",
        enableSorting: true,
        cell: (cellProps) => <div style={{ width: "90px", whiteSpace: "normal" }}>{cellProps.row.original.endDate}</div>
      },
      {
        header: "Parçalar Eklemler",
        accessorKey: "attachments",
        enableSorting: false,
        cell: (cellProps) => (
            <div className="text-center fs-5 text-dark cursor-pointer">
              {cellProps.row.original.id % 2 === 0 ? <i className="mdi mdi-paperclip"></i> : <i className="mdi mdi-plus-circle-outline"></i>}
            </div>
        )
      },
      {
        header: "Mesafe",
        accessorKey: "distance",
        enableSorting: true,
      },
      {
        header: "Bahis Elde",
        accessorKey: "bidWon",
        enableSorting: true,
        cell: (cellProps) => {
          const isWon = cellProps.row.original.bidWon;
          return (
            <div className="fw-medium text-dark text-center">
              <i className={`mdi ${isWon ? 'mdi-check' : 'mdi-close-circle'} fs-5`}></i><br/>
              {isWon ? "EVET" : "HAYIR"}
            </div>
          );
        }
      },
      {
        header: "Tarife Hizmet",
        accessorKey: "price",
        enableSorting: true,
        cell: (cellProps) => <span className="fw-medium">{cellProps.row.original.price} €</span>
      },
      {
        header: "Eylemler",
        enableSorting: false,
        cell: (cellProps) => {
          const rowId = cellProps.row.original.id;
          return (
            <div className="d-flex align-items-center gap-1">
              <UncontrolledDropdown>
                <DropdownToggle className="btn btn-light btn-sm border-secondary text-dark d-flex align-items-center">
                  <span className="fw-bold me-1">A</span> 
                  <i className="mdi mdi-menu-down"></i>
                </DropdownToggle>
                <DropdownMenu>
                  {/* Google Maps linkindeki string literal hatası düzeltildi */}
                  <DropdownItem href={`http://maps.google.com/?q=from+${cellProps.row.original.startCity}+to+${cellProps.row.original.endCity}`} target="_blank">Google haritası</DropdownItem>
                  <DropdownItem href="#">Roma2Rio</DropdownItem>
                  <DropdownItem href="#">Michelin Yolu</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              
              <Button color="light" size="sm" className="border-secondary text-dark px-2" id={`instructionTooltip-${rowId}`}>
                <i className="mdi mdi-content-copy"></i>
              </Button>
              <UncontrolledTooltip placement="top" target={`instructionTooltip-${rowId}`}>
                {rowId} numaralı rota için genel talimatları indirin
              </UncontrolledTooltip>
            </div>
          );
        }
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Partner Expedicar" breadcrumbItem="Gezilerim" />
          
          <div className="d-flex justify-content-between align-items-center mb-4">
              <h2>Gezilerim</h2>
              <Button color="light" size="sm" className="text-primary border-primary bg-transparent fw-medium">
                  <i className="mdi mdi-help-circle-outline me-1"></i> Görevlerimi nasıl takip ederim?
              </Button>
          </div>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="pt-0 pb-0 border-bottom">
                  <Nav tabs className="nav-tabs-custom">
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "1" }, "fw-medium")} onClick={() => toggleTab("1")} style={{ cursor: 'pointer' }}>
                        Rotaların listesi
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "2" }, "fw-medium")} onClick={() => toggleTab("2")} style={{ cursor: 'pointer' }}>
                        Yolculukların ihracatı
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardBody>
                
                <CardBody>
                  {/* Filtre ve Arama Alanı */}
                  <Row className="mb-4 align-items-end">
                      <Col sm={3}>
                          <Input type="select" className="form-select">
                              <option>Tüm yolculuklar</option>
                              <option>Tamamlananlar</option>
                              <option>Bekleyenler</option>
                          </Input>
                      </Col>
                      <Col sm={9}>
                          <div className="d-flex justify-content-between align-items-center">
                              <span className="text-muted">Bu arama kriterleri için {tripsData.length} yolculuk var.</span>
                              <div className="d-flex align-items-center">
                                  <label className="me-2 mb-0 fw-medium">Arama:</label>
                                  <Input type="text" placeholder="Anahtar kelime" className="form-control form-control-sm me-2" style={{width: '200px'}} />
                                  <Button color="light" size="sm" className="border-secondary"><i className="mdi mdi-refresh"></i></Button>
                              </div>
                          </div>
                      </Col>
                  </Row>

                  {isLoading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" /> <p className="mt-2 text-muted">Gezileriniz yükleniyor...</p>
                    </div>
                  ) : tripsData.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={tripsData}
                      isGlobalFilter={false}
                      isCustomPageSize={true}
                      isPagination={true}
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-bordered"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  ) : (
                    <div className="text-center text-muted py-5">
                        Size ait henüz bir gezi/rota kaydı bulunmamaktadır.
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Gezilerim;